<app-pan-modal [isOpen]="isVisible()" (modalWillOpen)="reset()" (modalClose)="isVisible.set(false)">
  <div header>{{ readOnly() ? 'View Invoice' : 'Manage AR Invoice' }}</div>

  <div body class="flex flex-col gap-4">
    <app-pan-inline-alert type="info">
      <span class="italic">Scanning this QR code will redirect you to 365's platform.</span>
    </app-pan-inline-alert>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <app-pan-form-control>
        <app-pan-floating-label>Base Value</app-pan-floating-label>
        <input panInput type="number" [ngModel]="report().amount" [disabled]="true" data-testid="asset-recovery-invoice-base-value" />
      </app-pan-form-control>

      <app-pan-form-control>
        <app-pan-floating-label for="addedFees">Added Fees</app-pan-floating-label>
        <input
          panInput
          panNumericInput
          id="addedFees"
          type="number"
          [(ngModel)]="addedFees"
          [disabled]="readOnly()"
          placeholder="0"
          min="0"
          data-testid="asset-recovery-invoice-added-fees"
        />
      </app-pan-form-control>

      <app-pan-form-control>
        <app-pan-floating-label># of Incidents Included</app-pan-floating-label>
        <input panInput type="number" [ngModel]="report().incidents.length" [disabled]="true" />
      </app-pan-form-control>

      <app-pan-form-control>
        <app-pan-floating-label>Total Amount</app-pan-floating-label>
        <input panInput type="number" [ngModel]="totalAmount()" [disabled]="true" data-testid="asset-recovery-invoice-total-amount" />
      </app-pan-form-control>
    </div>

    <app-pan-form-control>
      <app-pan-floating-label>QR Code Preview</app-pan-floating-label>
      <div class="flex items-center justify-center min-h-40" data-testid="asset-recovery-invoice-qr-preview">
        <img [src]="qrCodeUrl()" alt="QR code linking to the Asset Recovery invoice" />
      </div>
    </app-pan-form-control>
  </div>

  <div footer class="flex gap-2">
    <button panButton panModalClose color="default" data-testid="asset-recovery-invoice-cancel" [disabled]="saving()">
      {{ readOnly() ? 'Close' : 'Cancel' }}
    </button>
    @if (!readOnly()) {
      <button panButton color="primary" data-testid="asset-recovery-invoice-confirm" [disabled]="saving()" (click)="confirm()">
        {{ saving() ? 'Saving...' : 'Confirm' }}
      </button>
    }
  </div>
</app-pan-modal>
